import {
  Box,
  Flex,
  Icon,
  Stack,
  StackDivider,
  Wrap,
  WrapItem,
} from '@chakra-ui/react';
import { FC } from 'react';
import { ParagraphFarmCategoryTeaserFragment } from '../../../generated/types';
import { IoCheckmarkCircle } from '@react-icons/all-files/io5/IoCheckmarkCircle';

interface FarmCategoryListGroupedProps {
  categories: ParagraphFarmCategoryTeaserFragment[];
  categoryIds?: number[];
}

export const FarmCategoryListGrouped: FC<FarmCategoryListGroupedProps> = ({
  categories,
  categoryIds,
}) => {
  return (
    <Wrap
      direction={{
        base: 'column',
        md: 'row',
      }}
      spacing={4}
    >
      {categories.map((categoryParagraph, i) => {
        if (!categoryParagraph.category.showOnFarm) return null;
        if (categoryIds && !categoryIds.includes(categoryParagraph.category.id))
          return null;

        return (
          <WrapItem key={i} flexDirection="column" color="primary">
            <Box fontWeight="bold">{categoryParagraph.category.title}</Box>
            <Box ml={4} mt={2}>
              {categoryParagraph.subCategories.map((subCategory, j) => {
                if (!subCategory.showOnFarm) return null;

                return (
                  <Box key={j}>
                    <Flex alignItems="center">
                      <Icon
                        mr={1}
                        fontSize="xl"
                        as={IoCheckmarkCircle}
                        color="primary"
                      />
                      {subCategory.title}
                    </Flex>
                  </Box>
                );
              })}
            </Box>
          </WrapItem>
        );
      })}
    </Wrap>
  );
};
